import _ from 'lodash';

import {getTokenData} from 'api/request';
import {actions as routerActions} from 'redux-router5';

import {userActionTypes} from './actionTypes';
import {genericLoad, genericPut} from '../helpers/reduxHelpers';
import {asyncLoad, asyncPost} from './.';
import {getGuestToken} from '../paymentApp/authenticate';
import {handleError} from '../helpers';
import {changePageSize} from './tableActions';
import {Paging} from '../helpers/constants';

export const loadToken = () => dispatch => {
  return getTokenData()
    .then(token => {
      dispatch({
        type: userActionTypes.TOKEN.COMPLETE,
        payload: token.tokenData,
      });

      return true;
    })
    .catch(error => {
      dispatch({type: userActionTypes.TOKEN.COMPLETE, error});
    })
    .finally(() => {
      dispatch({
        type: userActionTypes.TOKEN.LOADING,
        field: 'token',
        loading: false,
      });
    });
};

export const loadGuestToken = params => dispatch => {
  dispatch({
    type: userActionTypes.TOKEN.LOADING,
    field: 'token',
    loading: true,
  });
  return getGuestToken(params)
    .then(token => {
      if (token && token.tokenData) {
        dispatch({
          type: userActionTypes.TOKEN.COMPLETE,
          payload: token.tokenData,
        });
        dispatch({
          type: userActionTypes.TOKEN.LOADING,
          field: 'token',
          loading: false,
        });
        return true;
      } else {
        throw new Error('invalid access token');
      }
    })
    .catch(error => {
      dispatch({type: userActionTypes.TOKEN.COMPLETE, error});
      handleError('Authentication error', error, dispatch);
      dispatch(
        routerActions.navigateTo('error', {
          title: 'Authentication Error',
          error: `Sorry! It looks like an issue occurred : ${
            error.message
            }. Please contact your service provider to resend this link.`,
        }),
      );
      dispatch({
        type: userActionTypes.TOKEN.LOADING,
        field: 'token',
        loading: false,
      });
      return false;
    });
};

export const loadTimezone = () => dispatch =>
  genericLoad({
    dispatch,
    field: 'timezone',
    includePortal: false,
    payloadModifier: data => data.result,
    stateField: 'timezone',
    title: 'timezone',
    type: userActionTypes.TIMEZONE,
    url: '/users/timezone/iana',
  });

export const loadUserPreferences = () => async dispatch => {
  const prefs = await genericLoad({
    dispatch,
    field: 'userPreferences',
    includePortal: false,
    payloadModifier: data => _.keyBy(data.results, 'key'),
    stateField: 'preferences',
    title: 'user preferences',
    type: userActionTypes.USER_PREFERENCE,
    url: `/users/me/preferences/`,
  });

  dispatch(
    changePageSize(
      prefs.tlDashboardPageSize
        ? Number(prefs.tlDashboardPageSize.value)
        : Paging.initialPageSize,
    ),
  );

  return prefs;
};

export const updateUserPreference = (key, value, hideSuccessToastr) => (
  dispatch,
  getState,
) =>
  genericPut({
    body: {key: key, userId: getState().user.tokenData.mhd_id, value},
    dispatch,
    field: 'userPreference',
    hideSuccessToastr,
    includePortal: false,
    stateField: key,
    title: 'user preference',
    type: userActionTypes.UPDATE_USER_PREFERENCE,
    url: `/users/me/preferences/${key}`,
  });

export const sendMobileLink = (isSms, value) => (dispatch, getState) => {
  const {tokenData} = getState().user;
  const body = {userId: tokenData.mhd_id, portalId: tokenData.portal_id};
  body[isSms ? 'phoneNumber' : 'emailAddress'] = value;
  return asyncPost({
    params: {useMAPI: true},
    url: `/users/mobileApp${isSms ? 'Sms' : 'Email'}`,
    useMAPI: true,
    body,
    dispatch,
    successMessage: `The ${isSms ? 'text message' : 'email'} was sent!`,
  });
};

export const getUsers = (searchValue = null, fields = null) => async dispatch =>
  await asyncLoad({
    dispatch,
    title: 'Users',
    url: `/users/staff${fields ? `?fields=${fields}` : ''}${
      searchValue ? `${fields ? '&' : '?'}name=${searchValue}` : ''
      }`,
  });



// WEBPACK FOOTER //
// ./src/actions/userActions.js